module.exports = __webpack_public_path__ + "static/media/note.526dbf96.svg";